exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".nav-link{cursor:pointer}ul .nav-dropdown-items{padding-left:10px!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/components/Sidebar/Sidebar.vue"],"names":[],"mappings":"AACA,UACE,cAAe,CAChB,AACD,uBACE,2BAA8B,CAC/B","file":"Sidebar.vue","sourcesContent":["\n.nav-link {\n  cursor:pointer;\n}\nul .nav-dropdown-items {\n  padding-left: 10px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e2cae62","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar/Sidebar.vue
// module id = 1408
// module chunks = 0